import { Outlet, NavLink } from "react-router-dom";
import { Home, CalendarDays, TrendingUp, MessageCircle, User, UtensilsCrossed } from "lucide-react";

const NAV = [
  { to: "/app", icon: Home, label: "Today", end: true, testId: "nav-today" },
  { to: "/app/program", icon: CalendarDays, label: "Program", testId: "nav-program" },
  { to: "/app/nutrition", icon: UtensilsCrossed, label: "Nutrition", testId: "nav-nutrition" },
  { to: "/app/progress", icon: TrendingUp, label: "Progress", testId: "nav-progress" },
  { to: "/app/messages", icon: MessageCircle, label: "Messages", testId: "nav-messages" },
  { to: "/app/profile", icon: User, label: "Profile", testId: "nav-profile" },
];

export default function CustomerLayout() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex justify-center">
      <div className="w-full max-w-md min-h-screen relative pb-24 border-x border-white/5">
        <Outlet />
        <nav className="fixed bottom-0 inset-x-0 max-w-md mx-auto glass border-t border-border flex justify-around py-2 z-50">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testId}
              className={({ isActive }) => `flex flex-col items-center gap-1 px-2 py-1.5 flex-1 transition-colors ${isActive ? "text-brand" : "text-tertiary"}`}>
              <n.icon className="w-5 h-5" />
              <span className="text-[9px] font-semibold">{n.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
